<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid" *ngIf="accessService.hasAccess([], ['campaign.create'])">
  <div class="row align-items-center">
    <div class="col-auto">
      <h5 class="title-secondary">{{ 'CAMPAIGN.CAMPAIGN_LIST.TITLE' | translate }}</h5>
    </div>
    <div *ngIf="currentStep === 1" class="col-auto ml-auto">
      <button type="button" class="btn btn-link" (click)="clearFilters()">
        {{ 'CLEAR_FILTERS' | translate }}
      </button>
    </div>
  </div>

  <kendo-grid
    [data]="data"
    [pageSize]="requestsResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event)"
    [style.height]="'100%'"
    [loading]="loader"
    (columnVisibilityChange)="onVisibilityChange($event)"
  >
    <kendo-grid-column
      [width]="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      class="text-center"
      headerClass="text-center"
      field="id"
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.ID' | translate }}"
      filter="numeric"
      [width]="120"
      [hidden]="isHiddenColumn('id')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="event.formattedName"
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.EVENT' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('event.formattedName')"
      [sortable]="false"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-event-select [filter]="filter"></app-kendo-event-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        <a [routerLink]="['/events/view']" [queryParams]="{ id: dataItem?.event?.id }" target="_blank">
          {{ dataItem?.event?.formattedName }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="event.event_group.name"
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.GROUP_NAME' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('event.event_group.name', true)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-event-group-select [filter]="filter" [field]="'event.event_group_id'"></app-kendo-event-group-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        <a
          [routerLink]="['/event-groups/view']"
          [queryParams]="{ id: dataItem?.event?.event_group?.id }"
          target="_blank"
        >
          {{ dataItem?.event?.event_group?.name }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="template.name"
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.TEMPLATE' | translate }}"
      [hidden]="isHiddenColumn('template.name', true)"
      [sortable]="false"
      [filterable]="false"
    >
    </kendo-grid-column>

    <kendo-grid-column
      field="add_sale"
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.ADD_SALE' | translate }}"
      [hidden]="isHiddenColumn('add_sale', true)"
      filter="boolean"
      [class]="'text-center'"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.add_sale"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="add_rl"
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.ADD_RL' | translate }}"
      [hidden]="isHiddenColumn('add_rl', true)"
      filter="boolean"
      [class]="'text-center'"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.add_rl"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="sales"
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.SALES_COUNT' | translate }}"
      [hidden]="isHiddenColumn('sales', true)"
      [sortable]="false"
      [filterable]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.sales.length }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="creator.fake_first_name"
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.CREATOR' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('creator.fake_first_name')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-user-select [filter]="filter" [field]="'creator_id'"></app-kendo-user-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.creator?.fake_first_name }} {{ dataItem?.creator?.fake_last_name }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="created_at"
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.CREATED_AT' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('created_at', true)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.created_at.getDate() }} {{ dataItem.created_at.getHours() }}:{{ dataItem.created_at.getMinutes() }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.ACTIONS' | translate }}"
      [width]="100"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <a
          [routerLink]="['/campaign/view']"
          [queryParams]="{ id: dataItem?.id }"
          target="_blank"
          class="btn btn-info btn-ico"
          [ngbTooltip]="'CAMPAIGN.BUTTONS.VIEW' | translate"
          container="body"
        >
          <i class="fal fa-eye"></i>
        </a>
        <a
          [routerLink]="['/campaign/create']"
          [queryParams]="{ resend: dataItem?.id }"
          target="_blank"
          class="btn btn-info btn-ico"
          [ngbTooltip]="'CAMPAIGN.BUTTONS.RESEND' | translate"
          container="body"
        >
          <i class="fa fa-rotate-right"></i>
        </a>
        <app-delete-button [swal]="{}" (confirm)="delete(dataItem)"> </app-delete-button>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
    </ng-template>
  </kendo-grid>
</div>
